(function () {
  var params = new URLSearchParams(location.search);

  function getCookie(n) {
    var m = document.cookie.match('(^|;)\\s*' + n + '\\s*=\\s*([^;]+)');
    return m ? m.pop() : '';
  }

  function getFbc() {
    var c = getCookie('_fbc');
    if (c) return c;
    var id = params.get('fbclid');
    return id ? 'fb.1.' + Date.now() + '.' + id : '';
  }

  var email = (params.get('em') || '').trim().toLowerCase();

  var eid = sessionStorage.getItem('lakshmi_lead_eid');
  var alreadyFired = !!eid;
  if (!eid) {
    eid = 'lead-' + Date.now() + '-' + Math.random().toString(36).slice(2, 10);
    sessionStorage.setItem('lakshmi_lead_eid', eid);
  }

  if (!alreadyFired) {
    if (typeof fbq === 'function') {
      if (email) fbq('setUserProperties', { em: email });
      fbq('track', 'Lead', {
        content_name: 'Quiz Oli Essenziali',
        content_category: params.get('obiettivo') || '',
        currency: 'EUR',
        value: 0
      }, { eventID: eid });
    }

    fetch('https://hook.eu1.make.com/7x6j5j3f5psoh28xqgru0uh22sjtgf7r', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({
        event_id: eid,
        event_time: Math.floor(Date.now() / 1000),
        email: email,
        fbp: getCookie('_fbp'),
        fbc: getFbc(),
        user_agent: navigator.userAgent,
        event_source_url: location.href,
        nome: params.get('nome') || '',
        obiettivo: params.get('obiettivo') || ''
      }),
      keepalive: true
    }).catch(function () {});
  }

  if (params.has('em') || params.has('fbclid')) {
    params.delete('em');
    params.delete('fbclid');
    var clean = location.pathname + (params.toString() ? '?' + params : '');
    history.replaceState(null, '', clean);
  }
})();

var params = new URLSearchParams(document.location.search);
var bundlename = params.get("nome");
var aggettivo  = params.get("aggettivo");
var colore     = params.get("colore");
var obiettivo  = params.get("obiettivo");

document.getElementById("bundle-name").innerHTML = bundlename;
document.getElementById("aggettivoli").value = aggettivo;
document.getElementById("coloreoli").value = colore;
document.getElementById("obiettivoli").value = obiettivo;
document.getElementById(aggettivo).style.display = "block";
document.getElementById(colore).style.display = "block";
document.getElementById(obiettivo).style.display = "block";

const form = document.getElementById("bundle-form");

// prefisso locale: su /de/ o /en/ le fetch devono essere prefissate
var ROOT = (window.Shopify && Shopify.routes && Shopify.routes.root) || "/";
if (ROOT.slice(-1) !== "/") ROOT += "/";

form.addEventListener("submit", async (e) => {
  e.preventDefault();

  const group1 = document.getElementById("aggettivoli").value;
  const group2 = document.getElementById("coloreoli").value;
  const group3 = document.getElementById("obiettivoli").value;

  const bundleId = new Date().getTime();
  const btn = form.querySelector('[type="submit"]');
  if (btn) btn.disabled = true;

  try {
    const res = await fetch(ROOT + "cart/add.js", {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
        "Accept": "application/json"
      },
      body: JSON.stringify({
        items: [
          { id: group1, quantity: 1, properties: { _oilbundleId: bundleId } },
          { id: group2, quantity: 1, properties: { _oilbundleId: bundleId } },
          { id: group3, quantity: 1, properties: { _oilbundleId: bundleId } }
        ]
      })
    });

    if (!res.ok) throw await res.json();

    // aggiorna il contatore carrello del tema
    document.dispatchEvent(new CustomEvent("cart:build"));

    // apre la drawer custom (render + sync omaggio automatici)
    if (typeof window.cgdOpen === "function") {
      window.cgdOpen();
    } else {
      window.location.href = ROOT + "cart";
    }
  } catch (err) {
    console.error("[bundle] add.js fallito", err);
    if (btn) btn.disabled = false;
    return;
  }

  if (btn) btn.disabled = false;
});